import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import rootReducer from '../reducers/rootReducer';

/* istanbul ignore next */
function logActions() {
  return (next) => (action) => {
    if (window && window.console && window.console.log) {
      const { type, payload } = action;
      window.console.log('[Redux Dispatch]', new Date().valueOf(), type, payload);
    }
    return next(action);
  };
}

export const createStoreWithMiddleware = composeWithDevTools(applyMiddleware(thunk, logActions))(
  createStore,
);

export function createNewStore(initialState) {
  return createStoreWithMiddleware(rootReducer, initialState);
}

const store = createNewStore();

export default store;
